import Vue from 'vue'
import Router from 'vue-router'
import topHeader from '../components/topHeader'
import swipe from '../components/swipe'
import footer from '../components/footer'
import shareContent from '../components/shareContent'
import aboutContent from '../components/aboutContent'
import downloadContent from '../components/downloadContent'
import jobContent from '../components/jobContent'
import homePage0 from '../components/homePage0'
import homePage1 from '../components/homePage1'
import homePage2 from '../components/homePage2'
import aps from '../components/aps'
import ac1 from '../components/ac1'
import ac2 from '../components/ac2'
import ac3 from '../components/ac3'
import open from '../components/open'
import login from '../components/login'
import backend from '../components/backend'
import index from "../components/main/index"
import printer from "../components/main/printer"
import log from "../components/main/log"
import printTest from "../components/main/printTest"
import printRecord from "../components/main/printRecord"
import sim from "../components/main/sim"
import deposit from "../components/main/deposit"
import callback from "../components/main/callback"
import center from "../components/main/center"

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        components: {
            topHeader: topHeader,
            swipe: swipe,
            homePage0: homePage0,
            homePage1: homePage1,
            homePage2: homePage2,
            footer: footer
        },
        beforeEnter(to, from, next) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) { item.className = '' });
            next();
        }
    },
    {
        path: '/aps',  // 应用场景
        components: {
            topHeader: topHeader,
            aps: aps,
            footer: footer
        }
    },
    {
        path: '/brief',
        components: {
            topHeader: topHeader,
            footer: footer,
            aboutContent: aboutContent
        }
    },
    {
        path: '/ac1',
        components: {
            topHeader: topHeader,
            footer: footer,
            ac1: ac1
        }
    },
    {
        path: '/ac2',
        components: {
            topHeader: topHeader,
            footer: footer,
            ac2: ac2
        }
    },
    {
        path: '/ac3',
        components: {
            topHeader: topHeader,
            footer: footer,
            ac3: ac3
        }
    },
    {
        path: '/open',
        components: {
            topHeader: topHeader,
            open: open
        }
    },

    {
        path: '/cooperation',
        components: {
            topHeader: topHeader,
            shareContent: shareContent,
            footer: footer
        }
    }, {
        path: '/job',
        components: {
            topHeader: topHeader,
            footer: footer,
            jobContent: jobContent
        }
    }, {
        path: '/contact',
        components: {
            topHeader: topHeader,
            footer: footer,
            downloadContent: downloadContent
        }
    }, {
        path: '/login',
        components: {
            topHeader: topHeader,
            footer: footer,
            login: login
        }
    }, {
        path: '/backend',
        components: {
            topHeader: topHeader,
            backend: backend
        },
        children: [{
            path: "index",
            component: index
        }, {
            path: "center",
            component: center
        }, {
            path: "printer",
            component: printer
        }, {
            path: "log",
            component: log
        }, {
            path: "printTest",
            component: printTest
        }, {
            path: "printRecord",
            component: printRecord
        }, {
            path: "sim",
            component: sim
        }, {
            path: "deposit",
            component: deposit
        }, {
            path: "callback",
            component: callback
        }]
    }],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js